import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { formatTRY } from "@/lib/format";

// Cari kartından "İade Al": faturalaşmış siparişi seçip sipariş detayında iade penceresini açar
export default function ReturnPickDialog({ customerId, onClose }) {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/orders", { params: { customer_id: customerId, status: "faturalasti", limit: 100 } })
      .then(({ data }) => setItems((data.items || data).filter((o) => o.customer_id === customerId && (o.returned_total_try || 0) < (o.grand_total_try || 0) - 0.01)))
      .catch(() => setItems([]));
  }, [customerId]);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent aria-describedby={undefined} className="max-w-2xl" data-testid="return-pick-dialog">
        <DialogHeader><DialogTitle>İade Al – fatura seçin</DialogTitle></DialogHeader>
        {!items ? <div className="h-20 animate-pulse bg-slate-50 rounded" /> : items.length === 0 ? <p className="text-[13px] text-slate-500" data-testid="return-pick-empty">Bu cariye ait iade edilebilir faturalaşmış sipariş yok.</p> : (
          <div className="max-h-[60vh] overflow-auto"><table className="erp-table text-[12px]"><thead><tr><th>Fatura</th><th>Sipariş</th><th>Tarih</th><th className="text-right">Tutar</th><th /></tr></thead>
            <tbody>{items.map((o) => (
              <tr key={o.id} data-testid={`return-pick-${o.order_no}`}><td className="font-mono">{o.invoice_no}</td><td className="font-mono">{o.order_no}</td><td>{o.invoice_date}</td>
                <td className="text-right font-mono">{formatTRY(o.grand_total_try)}</td>
                <td><Button size="sm" variant="outline" onClick={() => navigate(`/siparisler/${o.id}?iade=1`)} data-testid={`return-pick-open-${o.order_no}`}>İade al</Button></td></tr>))}</tbody></table></div>)}
      </DialogContent>
    </Dialog>
  );
}
